import { COUNTRY_OPTIONS, FIELD_PATHS, PII_FIELD_MASKING_CLASS } from '@funnels/constants';
import { ApplicantEntityIndex } from '@funnels/types';

import { DropdownField } from '../../../Fields';

interface CitizenshipProps extends ApplicantEntityIndex {
  isOptional?: boolean;
  isDisabled?: boolean;
}

export const Citizenship = ({ applicantIndex, isOptional, isDisabled }: CitizenshipProps) => (
  <DropdownField
    label="Country of citizenship"
    subLabel="If they have a dual citizenship, select one that they relate most to."
    name={FIELD_PATHS.APPLICANT_CITIZENSHIP(applicantIndex)}
    options={COUNTRY_OPTIONS}
    isOptional={isOptional}
    isDisabled={isDisabled}
    className={PII_FIELD_MASKING_CLASS}
  />
);
